module.exports = __webpack_public_path__ + "media/דובדבן.d8bb0988.mp3";